export const COMMON__ALL_RIGHTS_RESERVED = "global__all_rights_reserved";
export const COMMON__ERROR_403 = "global__error_403";
export const COMMON__ERROR_404 = "global__error_404";
export const COMMON__GLOBAL_BUTTONS__CLOSE = "global_buttons__close";
export const COMMON__HOME = "common__home";
export const COMMON__INT_EN = "common__intEn";
export const COMMON__INT_ES = "common__intEs";
export const COMMON__INT_GL = "common__intGl";
export const COMMON__LOADING_DESCRIPTION = "common__loading_description";
export const COMMON__LOGIN = "common__login";
export const COMMON__LOGOUT = "common__logout";
export const COMMON__NO = "common__no";
export const COMMON__PRIVATE_PAGE = "common__private_page";
export const COMMON__PRIVACY_POLICY = "common__privacy_policy";
export const COMMON__TERMS_OF_USE = "terms_of_use";
export const COMMON__PUBLIC_PAGE = "common__public_page";
export const COMMON__WELCOME = "common__welcome";
export const COMMON__NO_LINE_INFORMATION = "common__no_line_information";
export const COMMON__YES = "common__yes";
export const STOP__SELECT = "stop__select";
export const LOCATION__ARTEIXO = "location__arteixo";
export const ERROR_BOUNDARY__TITLE = "error_boundary__title";
export const ERROR_BOUNDARY__DESCRIPTION = "error_boundary__description";
export const PLACEHOLDER_SEARCH = "placeholder__search";

